const {ENTER_KEY_CODE} = require('constants/index');

const handleOnEnter = (event, callback) =>{
    if(event.keyCode === ENTER_KEY_CODE){
        if(callback){
            callback();
        }
    }
}

module.exports = {
    handleOnEnter
}
